export const spanishUrl = '/espanol';
export const spanishStudentUrl = '/espanol-alumnos';
